const genderList = [
    { value: 1, text_en: 'Male', text_bn: 'পুরুষ' },
    { value: 2, text_en: 'Female', text_bn: 'নারী' }
]
const studentTypeList = [
  { value: 1, text_en: 'Direct Admission', text_bn: 'সরাসরি ভর্তি' },
  { value: 2, text_en: 'Online Admission Application', text_bn: 'অনলাইনে ভর্তির আবেদন' }
]

const traineeTypeList = [
  { value: 1, text_en: 'Teacher', text_bn: 'শিক্ষক/শিক্ষিকা' },
  { value: 2, text_en: 'Parent', text_bn: 'পিতা/মাতা' },
  { value: 3, text_en: 'Student', text_bn: 'শিক্ষার্থী' }
]

const religionList = [
  { value: 1, text_en: 'Muslim', text_bn: 'মুসলিম' },
  { value: 2, text_en: 'Hinduism', text_bn: 'হিন্দু' },
  { value: 3, text_en: 'Buddhism', text_bn: 'বৌদ্ধ' },
  { value: 4, text_en: 'Christianity', text_bn: 'খ্রিষ্টান' },
  { value: 5, text_en: 'Other', text_bn: 'অন্যান্য' }
]

const schoolRulesList = [
  {
      value: 1,
      text_bn: 'নির্দিষ্ট সময়ে স্কুলে পাঠাতে ও নিয়ে যেতে হবে।',
      text_en: 'Have to send him/her to school at the specified time.'
  },
  {
      value: 2,
      text_bn: 'নিয়মিত এ্যাসিমব্লীতে যোগদান করতে হবে।',
      text_en: 'Must attend regular assemblies.'
  },
  {
      value: 3,
      text_bn: 'স্কুলের ইউনিফর্ম পরে আসতে হবে।',
      text_en: 'Must come in school uniform.'
  },
  {
      value: 4,
      text_bn: 'নির্দিষ্ট সময়ে স্কুলের বেতন পরিশোধ করতে হবে, পর পর ৩ মাস বকেয়া থাকলে নাম কাটা যাবে।',
      text_en: 'The school salary has to be paid at the specified time, if there is arrears for 3 consecutive months, the name can be deducted.'
  },
  {
      value: 5,
      text_bn: 'প্রতিদিন স্কুলের ডায়েরী আনতে হবে এবং ডায়েরীতে লিখিত নির্দেশাবলী পালন করতে হবে।',
      text_en: 'Bring a school diary every day and follow the instructions written in the diary.'
  },
  {
      value: 6,
      text_bn: 'ব্যক্তিগত পরিস্কার-পরিচ্ছন্নতা বজায় রাখতে হবে।',
      text_en: 'Personal cleanliness must be maintained.'
  }
]

const observationList = [
  { value: 1, text_en: 'Student Attendance', text_bn: 'ছাত্র উপস্থিতি' },
  { value: 2, text_en: 'Guardians collaboration', text_bn: 'অভিভাবকের সহায়তা' },
  { value: 3, text_en: 'Perform specific household chores', text_bn: 'বাড়ির নির্দিষ্ট কাজ সম্পাদন' },
  { value: 4, text_en: 'Accept and follow the information / instructions written in the diary', text_bn: 'ডায়েরিতে লেখা তথ্য/নির্দেশনা গ্রহণ ও পালন' },
  { value: 5, text_en: 'Personal hygiene of students', text_bn: 'ছাত্রদের ব্যক্তিগত পরিস্কার পরিচ্ছন্নতা' }
]

function generateYearList () {
  const min = new Date().getFullYear()
  const oldMax = min - 8
  const newMax = min + 9
  const newYears = []
  const oldYears = []
  for (let i = oldMax; i < min; i++) {
      oldYears.push(i)
  }
  for (let j = min; j <= newMax; j++) {
      newYears.push(j)
  }
  const yearList = [...oldYears, ...newYears]
  return yearList
}

const yearList = generateYearList()

export default {
  genderList,
  religionList,
  yearList,
  studentTypeList,
  schoolRulesList,
  observationList,
  traineeTypeList
}
